<template>
  <div
    key="sectionContent"
    class="o-edition-section-content"
  >
    <MoleculeEditionSectionContentInfo
      :go-back-text="goBackText"
      :info-title="infoTitle"
      :info-sub-title="infoSubTitle"
      :section="section"
      :subject="subject"
    />
    <MoleculeEditionSectionContentSubject
      class="m-edition-section-content-subject"
      :is="molecule"
    />
  </div>
</template>

<script>
import mEditionMenu from '@/plugins/languages/es/molecules/m-edition-section-navigation-menu'

export default {
  name: 'OrganismEditionSectionContent',

  components: {
    MoleculeEditionSectionContentInfo: () => import('@/components/molecules/MoleculeEditionSectionContentInfo')
  },

  data () {
    return {
      goBackText: '',
      infoSubTitle: '',
      infoTitle: '',
      molecule: '',
      section: '',
      subedition: '',
      subject: ''
    }
  },

  watch: {
    $route (to, from) {
      this.getMolecule()
      this.$utils.hideAsideNavigationMenu()
    }
  },

  created () {
    this.getMolecule()
    this.$utils.hideAsideNavigationMenu()
  },

  methods: {
    getMolecule () {
      this.setInitialStates()
      this.section = 'Billing'
      let menu = mEditionMenu.mEditionMenu.billing
      for (const item in menu) {
        if (menu[item].subject === this.$route.params.subject) {
          this.infoTitle = menu[item].text
          this.subject = this.$utils.stringCapitalized(item)
          for (const child in menu[item].children) {
            if (menu[item].children[child].subedition === this.$route.params.subedition) {
              this.goBackText = menu[item].children[child].goBackText
              this.infoSubTitle = menu[item].children[child].text
              this.subedition = this.$utils.stringCapitalized(child)
              break
            }
          }
          break
        }
      }

      this.molecule = () => import('@/components/molecules/MoleculeEdition' + this.section + this.subject + this.subedition)
    },

    setInitialStates () {
      this.goBackText = ''
      this.infoSubTitle = ''
      this.infoTitle = ''
      this.section = ''
      this.subedition = ''
      this.subject = ''
    }
  }
}
</script>
